// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Overview_subtitle__vwCkS","title":"Overview_title__2dd8k"};